import React from "react";
import { ReactElement } from "react";
import * as DashboardStore from '../../store/DashboardStore';
import { connect } from 'react-redux';
import VehiclesTab from "./VehiclesTab";
import DevicesTab from "./DevicesTab";
import DashboardTab from "./DashboardTab";
import MapPopup from "../common/MapPopup";
import * as DashboardIcons from "./DashboardIcons";
import { VehicleChipMessages, VehicleChipMessagesDict, VehicleChipStatus, VehicleChipStyles } from "../common/DashboardVehicle";
import DanlawVehicle from "../../models/DanlawVehicle";
import DeviceShipment from "../../models/DeviceShipment";
import DeviceNotification from "../../models/DeviceNotification";
import { excludeSpecialCharacters } from "../../helpers/textHelpers";
import CutoverPage from "./CutoverPage";
import { PolicyInfo } from "../../models/PolicyInfo";
import GustoFlagStatus, { GustoFlag } from "../../models/GustoFlagStatus";
import { Redirect } from "react-router";

interface CustomerDashboardProps {

}

interface CustomerDashboardState {
    searchPolicyNumber: string;
    selectedVehicle: DanlawVehicle;
    singleVehicleMap: any;
    vehicles: DanlawVehicle[];
    eligibleProgram: any,
    policy: PolicyInfo | undefined,
    gustoFlags: GustoFlagStatus;
}

export function generateMapIconsWithId(vehicles: DanlawVehicle[], idValue: string): ReactElement[] {
    let icons: ReactElement[] = [];
    let index = 1;
    if (vehicles) {
        vehicles.forEach((vehicle: DanlawVehicle) => {
            let chipMessage = VehicleChipMessagesDict.find((chipMessage) => chipMessage.message === vehicle.chipMessage)?.status || "";
            icons.push(DashboardIcons.RelevantIcon(idValue + index, chipMessage));
            index++;
        });
    }
    return icons;
}

export function createMap(container: string, style?: string, center?: any, zoom?: number, dragPan = true, showZoomControls = true, interactive = true): any {
    const Radar = window.Radar;
    return Radar.ui.map({
        container: container,
        style: style || 'radar-default-v1',
        center: center,
        zoom: zoom,
        dragPan: dragPan,
        showZoomControls: showZoomControls,
        interactive: interactive
    });
}

export function createMapMarker(container: any, longAndLat: any, markerOptions?: any) {
    const Radar = window.Radar;
    return Radar.ui.marker(markerOptions)
        .setLngLat(longAndLat)
        .addTo(container);
}

export function zoomOnVehicle(vehicle: DanlawVehicle, vehiclesMap: any) {
    let selectedMarker: any = undefined;
    let markers = vehiclesMap.getMarkers();
    let zoomButton = document.getElementById("zoom-button" + vehicle.id) as HTMLElement;

    markers.forEach((marker: any) => {
        if (marker._element.id === ("svgIcon-" + vehicle.id)) {
            selectedMarker = marker;
        }
    });

    if (vehiclesMap.getZoom() >= 17) {
        vehiclesMap.fitToMarkers({ speed: 2, duration: 2500 });
    }
    else {
        vehiclesMap.flyTo({
            center: [selectedMarker._lngLat.lng, selectedMarker._lngLat.lat],
            zoom: 19,
            speed: 1,
            curve: 0.5,
            duration: 2500
        });
    }
}

export class CustomerDashboard extends React.Component<any, CustomerDashboardState> {
    constructor(props: CustomerDashboardProps) {
        super(props);
        this.state = {
            searchPolicyNumber: excludeSpecialCharacters(localStorage.getItem("policyNumber") ?? ""),
            selectedVehicle: {},
            singleVehicleMap: undefined,
            vehicles: [],
            eligibleProgram: undefined,
            policy: this.props.policy,
            gustoFlags: this.props.gustoFlags,
        };
    }

    async componentDidMount(): Promise<void> {
        const { searchPolicyWithoutCproa, getDriveEasyProgramEligibilityByPolicyNumber, policy } = this.props;
        const { searchPolicyNumber } = this.state;

        /// Set intial Dashboard button style
        let dashboardButton = document.getElementById("header-dashboard") as HTMLElement || HTMLElement;
        dashboardButton.style.fontWeight = "700";
        dashboardButton.style.background = "var(--Light-Mode-Light-Blue, #F0F4FB) !important";

        if (localStorage.getItem("policyNumber")) {
            localStorage.removeItem("policyNumber");
        }
        if (searchPolicyNumber) {
            await searchPolicyWithoutCproa(searchPolicyNumber.trim(), 'Policy', true);
        }

        this.checkForRefresh();
    }

    generateRedAlertDeviceNotifications(): DeviceNotification[] {
        const { vehicles } = this.props;
        let notifications: DeviceNotification[] = [];
        /*if (vehicles) {
            vehicles.forEach((vehicle: DanlawVehicle) => {
                if (vehicle.chipMessage === VehicleChipStatus) {
                    let vinlast6 = vehicle?.vin?.slice(-6);
                    let notifText = `The ${vehicle.vehicleType} VIN ${vinlast6} does not match the vehicles listed on the policy. To update the VIN, add a vehicle, or replace a vehicle, call us at (866) 509-9444.`;
                    notifications.push({ alertType: "Red Alert", notificationTitle:"Vehicle Not Listed, Please Contact Us", notificationText: notifText});
                }
            });
        }*/
        return notifications;
    }

    generatGrayAlertDeviceNotifications(): DeviceNotification[] {
        const { vehicles } = this.props;
        let notifications: DeviceNotification[] = [];
        /*if (vehicles) {
            vehicles.forEach((vehicle: DanlawVehicle) => {
                if (vehicle.chipMessage === VehicleChipStatus) {
                    notifications.push({ alertType: "Gray Alert",  notificationTitle:"Assign Vehicle to Finish Device Setup", notificationText: "To finish setup for the devices you recently installed, match them to the vehicle into which they were installed. Once matched, you’ll be able to track your vehicles' locations on the Vehicles page.",url:"#", urlDisplayText:"Assign Vehicle" });
                }
            });
        }*/
        return notifications;
    }

    generateGreenAlertDeviceNotifications(): DeviceNotification[] {
        const { vehicles } = this.props;
        let notifications: DeviceNotification[] = [];

        if (vehicles) {
            vehicles.forEach((vehicle: DanlawVehicle) => {
                if (vehicle.chipMessage === VehicleChipStatus.Connected) {
                    let obdlast4 = vehicle?.deviceInfo?.deviceId?.slice(-4);
                    let vinlast6 = vehicle?.vin?.slice(-6);
                    let notifText = `OBD ${obdlast4} was successfully plugged into the ${vehicle.vehicleType} ${vinlast6}.\n You can now track your vehicle’s location and status on the Vehicles page.`;
                    notifications.push({ alertType: "Green Confirmations", notificationTitle: "Device Successfully Connected!", notificationText: notifText, url: "#", urlDisplayText: "View Vehicles Page" });
                    return notifications;
                }
            });
        }

        return notifications;
    }

    generateInstallNoticeDeviceNotifications(): DeviceNotification[] {
        const { vehicles, shipments } = this.props;
        let notifications: DeviceNotification[] = [];

        if (shipments && shipments.length > 0) {
            shipments.forEach((shipment: DeviceShipment) => {
                if (shipment.shipmentStatus === "Delivered") {
                    if (vehicles) {
                        vehicles.forEach((vehicle: DanlawVehicle) => {
                            if (vehicle.chipMessage === VehicleChipStatus.Disconnected) {
                                shipment.deviceIds.forEach((deviceId: string) => {
                                    if (deviceId == vehicle.deviceInfo?.deviceId) {
                                        notifications.push({ alertType: "Install Notice", notificationTitle: "Install Your Device to Start Tracking", notificationText: "Your devices have arrived and are ready for install.", url: "#", urlDisplayText: "View Install Guide" });
                                        return notifications;
                                    }
                                });
                            }
                        });
                    }
                }
            });
        }

        return notifications;
    }

    checkForRefresh(): void {
        if (window.localStorage) {
            if (!localStorage.getItem('firstLoad') && (localStorage.getItem("returnUrl") || localStorage.getItem("clientId"))) {
                localStorage['firstLoad'] = true;
                window.location.reload();
            }
            else {
                localStorage.removeItem('firstLoad');
            }
        }
    }

    render(): ReactElement {
        const { vehicles, shipments, policy, popups, eligibleProgram, gustoFlags } = this.props;
        const { selectedVehicle } = this.state;
        let dashboardTabProps = {
            vehicles: vehicles,
            deviceShipments: shipments,
            policy: policy,
        }
        let vehiclesTabProps = {
            vehicles: vehicles,
            selectedVehicle: selectedVehicle,
            popups: popups,
        }
        let devicesTabProps = {
            vehicles: vehicles,
            deviceShipments: shipments,
            selectedVehicle: selectedVehicle,
            redAlertDeviceNotifications: this.generateRedAlertDeviceNotifications(),
            grayAlertDeviceNotifications: this.generatGrayAlertDeviceNotifications(),
            greenAlertDeviceNotifications: this.generateGreenAlertDeviceNotifications(),
            installNoticeDeviceNotifications: this.generateInstallNoticeDeviceNotifications(),
            policy: policy
        }
        let cutoverPageProps = {
            policy: policy,
            eligibleProgram: eligibleProgram,
        }
        if (policy?.programType == "DriveEasyProOBD2" || policy?.programType == "DriveEasyProELD") {
            if (gustoFlags?.gustoFlutterCounselorURL || gustoFlags?.gustoFlutterCustomerURL) {
                let urlParameters = "";
                let isAgent = false;

                let getEssidCookie = (): boolean | null => {
                    const value = localStorage.getItem("returnUrl") ?? "";
                    const clientId = localStorage.getItem("clientId") ?? "";
                    if (value === "" && clientId === "") {
                        return false;
                    }
                    else if ((value !== null && value !== "" && value.includes("clientId")) || clientId !== "") {
                        return true;
                    }
                    else if (value !== null && value !== "") {
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                let cookieValue = getEssidCookie();

                if (cookieValue) {
                    const returnUrl = localStorage.getItem("returnUrl");
                    const clientId = localStorage.getItem("clientId");
                    if ((returnUrl !== null && returnUrl !== "" && returnUrl.includes("clientId"))) {
                        isAgent = true;
                    } else if ((returnUrl === null || returnUrl === "") && clientId !== "") {
                        isAgent = true;
                    }
                }

                let returnUrl = localStorage.getItem("returnUrl") ?? "";
                let clientId = localStorage.getItem("clientId") ?? "";
                urlParameters = "?policyNumber=" + encodeURIComponent(btoa(policy?.policyNumber));
                if (returnUrl != "") {
                    urlParameters = urlParameters + "&returnUrl=" + encodeURIComponent(returnUrl);
                }
                if (clientId != "") {
                    urlParameters = urlParameters + "&clientId=" + encodeURIComponent(clientId);
                }
                let flutterUrl = isAgent ? gustoFlags?.gustoFlutterCounselorURL : gustoFlags?.gustoFlutterCustomerURL;
                let url = flutterUrl + urlParameters;
                window.location.href = url;
                return (<></>);
            }
        }
        if (policy?.programType == "DriveEasyPro" || policy?.programType == "OffCmt" || (policy?.programType == "DriveEasyProDashcam" && !policy?.isEnrolled) || !policy || !policy?.programType || policy?.programType == "") {
            return (
                <>
                    <CutoverPage {...cutoverPageProps} />
                </>
            )
        }
        else if (policy?.programType == "DriveEasyProDashcam" && policy?.isEnrolled) {
            return (
                    <Redirect to="/TelematicsPolicyManagment" />
            )
        }
        else {
            return (
                <>
                    <DashboardTab {...dashboardTabProps} />
                    <VehiclesTab {...vehiclesTabProps} />
                    <DevicesTab {...devicesTabProps} />
                </>
            )
        }
    }
}

const mapStateToProps = (state: any, ownProps: any) => ({
    error: state.dshs.error,
    selectedVehicle: state.drivers.policy,
    isLoading: state.drivers.isLoading,
    loggedInUser: state.loggedInUser,
    vehicles: state.dshs.vehicles,
    shipments: state.dshs.shipments,
    policy: state.dshs.policy,
    popups: state.dshs.popups,
    eligibleProgram: state.dshs.eligibleProgram,
    gustoFlags: state.dshs.gustoFlags,
});

export default connect(
    mapStateToProps,
    DashboardStore.actionCreators,
)(CustomerDashboard as any);
